module.exports = __webpack_public_path__ + "img/LONG-SLEEVE-TEE_FRONT_WHITE-FRONT.2f27a637.jpg";